/**
 * Screens where pulling down must NOT rebuild the page. The ONE place to add or remove a screen.
 * (A route can also opt out on its own with `data: { pullRefresh: false }`.)
 * Only the default "rebuild this page" is blocked here: a page that registers its own refresh through
 * PullToRefreshService.attach() always keeps it (that is an explicit opt-in).
 * Patterns are tested against the path only (no query, no #fragment).
 */
export const PULL_REFRESH_BLOCKED: RegExp[] = [
  // signing in, signing up, onboarding, invitations, referral and legal short links
  /^\/(login|register|register-company|register-user|registration|account-setup|add-user-to-exisiting-company|user-added-to-existing-company|confirmation|all-set|post-login|join-as-affiliate|unsubscribe|get-the-app)(\/|$)/,
  /^\/affiliate\/(apply|verification|payout-account)(\/|$)/,
  /^\/(r|l|legal)\//,
  // payments and the plan choice / checkout steps (a rebuild could reset a half-made purchase)
  /^\/payment/,
  /^\/subscriptions\/?$/,
  /^\/subscription(-management)?\/?$/,
  /^\/subscriptions\/subscription-management/,
  /^\/tally-sheet\/(subscribe|account-setup)/,
  /^\/plan-management-unavailable/,
  // share-link redirect pages (they only forward to the real page)
  /^\/s\/(p|r|x)\//,
  // errors, locked and offline screens
  /^\/(error|offline-locked|offline-unavailable|pagenotfound|unauthorized|restrictedPage)(\/|$)/,
  // calculators: what was typed in would be lost
  /^\/utility\//,
  /^\/public\//,
];

/**
 * Screens with forms. A rebuild is only allowed there when the route has the unsaved-changes guard
 * (canDeactivate), because that is what protects typed-in data; without it the pull does nothing.
 */
export const PULL_REFRESH_FORM_LIKE: RegExp[] = [
  /^\/(add|edit)\//,
  /^\/(profile|account-details|company|settings|manage|licenses)(\/|$)/,
];
